import React from 'react';
import styled from 'styled-components';
import { translate, numberFormat } from '~/utils';

const ChartLabel = styled.text`
  font-size: 12px;
  text-anchor: end;
`;

const AxisLabel = styled(ChartLabel)`
  font-weight: bold;
  text-anchor: start;
`;

const Axis = ({ scale, ticks = [], margin }) => {
  const max = scale.domain()[1];

  const renderTick = (tick) => {
    const translation = translate(margin.left - 15, scale(tick));
    const prefix = tick >= max ? '≥ ' : '';

    return (
      <g key={translation} transform={translation}>
        <ChartLabel>
          {prefix}
          {numberFormat(tick)}
        </ChartLabel>
      </g>
    );
  };

  const axisTicks = ticks.map(renderTick);

  return <g transform={translate(-margin.left, 4)}>{axisTicks}</g>;
};

export default Axis;
